import React, {useEffect, useState} from "react";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {GET_STATUS} from "../graphql/queries/gqlGetStatus";
import {IStatus} from "../../models/Status";
import {Card, CardContent, CardHeader, Divider, Typography} from "@mui/material";

export const Status: React.FC = (_) => {
	const [data, setData] = useState<IStatus>();
	
	const fetch = () => {
		graphQLServices.querytoolClient.query({
			query: GET_STATUS
		})
			.then(result => setData(result?.data?.status))
			.catch(function (error) {
				setData(undefined);
			});
	};
	
	useEffect(() => {
		const intervalId = setInterval(() => {
			fetch();
		}, 5000);
		// eslint-disable-next-line
		return () => clearInterval(intervalId);
	}, []);
	
	return (
		<>
			<Card variant={"outlined"}>
				<CardHeader title={"Status"}/>
				
				<CardContent>
					{!data &&
						<>Loading...</>
					}
					{data && <>
						<Typography gutterBottom variant="h6" component="div">
							Items to process: {data.jobItemQueueMessageCount}
						</Typography>
						<Typography gutterBottom variant="h6" component="div">
							Events to process: {data.eventQueueMessageCount}
						</Typography>
					</>}
				</CardContent>
				<Divider/>
			
			</Card>
		</>
	);
};

